import mitt from 'mitt';

export const EventBus = mitt();

export const useBus = () => ({
  $bus: EventBus,
});
